module.exports = __webpack_public_path__ + "img/commandImg1.71c4c331.png";